/**
 * Build-time version info, injected from package.json by vite.config.ts.
 * Never hard-code these — bump `version` and `lexa.releaseDate` in package.json
 * and they flow through here (see the `release` skill).
 */
export const APP_VERSION: string = __APP_VERSION__;
export const APP_DATE: string = __APP_DATE__;

export function versionLabel(): string {
  return `v${APP_VERSION} · ${APP_DATE}`;
}
